'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-ionicons/~/react/react.js
// module id = 756
// module chunks = 0